import React from "react";
import moment from 'moment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MultiSelectDropdown from "../../dropdown/MultiSelectDropdown.js";
import ValidationText from "../../../utils/validation/ValidationText.js";

const SecondPageDebitCreditNoteEntry = (props) => {
    return (
        <div className="item-form ">
            <div className="form-table">
                <div className="item-grp !flex !gap-2.5 !mb-3">
                    <div className="input-grp w-[20%]">
                        <label>{props.pageName === "DebitNoteEntry" ? "Debit Note No." : "Credit Note No."}</label>
                        <input
                            type="text"
                            id="noteNo"
                            name="noteNo"
                            disabled
                            autocomplete="off"
                            value={props.invoiceDetails.noteNo}
                            onChange={(event) =>
                                props.handleChange(event, "noteNo", "invoiceDetails")
                            }
                        />
                    </div>
                    <div className="input-grp w-[20%]">
                        <label>Date</label>
                        <input
                            type="date"
                            id="date"
                            name="date"
                            className={`inputFocus ${props.validState?.error?.date ? "errorInput" : ""}`}
                            autocomplete="off"
                            value={props.invoiceDetails.date}
                            onChange={(event) =>
                                props.handleChange(event, "date", "invoiceDetails")
                            }
                        />
                    </div>
                    {/* <ValidationText error={props.validState.error.date} /> */}
                </div>
                <div className="item-grp !flex !gap-2.5 !mb-3">
                    <div className="input-grp min-w-[30%]">
                        <label>Party Name</label>
                        <MultiSelectDropdown
                            drpIdentity="partyId"
                            options={props.partyDropdownList}
                            className={` ${props.validState?.error?.partyId ? "errorInput" : ""}`}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            onChange={(selected) =>
                                props.setFilterParameters(selected, "partyId")
                            }
                            allowSelectAll={false}
                            value={props.partyDropdownList.filter(
                                (party) =>
                                    party.value === props.invoiceDetails.partyId
                            )}
                        />
                        {/* <ValidationText error={props.validState.error.partyId} /> */}
                    </div>
                    <div className="input-grp w-full">
                        <label>Party GSTN No.</label>
                        <input
                            type="text"
                            id="partyGstnNo"
                            name="partyGstnNo"
                            className="inputFocus w-full"
                            autocomplete="off"
                            value={props.invoiceDetails.partyGstnNo}
                            onChange={(event) =>
                                props.handleChange(event, "partyGstnNo", "invoiceDetails")
                            }
                        />
                    </div>
                    <div className="input-grp w-full">
                        <label>HSN/SAC</label>
                        <input
                            type="text"
                            id="hsnSac"
                            name="hsnSac"
                            className="inputFocus w-full"
                            autocomplete="off"
                            value={props.invoiceDetails.hsnSac}
                            onChange={(event) =>
                                props.handleChange(event, "hsnSac", "invoiceDetails")
                            }
                        />
                    </div>
                    <span className='mt-[3.5px] border-l-2'></span>
                    <div className="input-grp min-w-[30%]">
                        <label>A/c Name</label>
                        <MultiSelectDropdown
                            drpIdentity="acId"
                            options={props.partyDropdownList}
                            closeMenuOnSelect={true}
                            className={` ${props.validState?.error?.acId ? "errorInput" : ""}`}
                            hideSelectedOptions={false}
                            onChange={(selected) =>
                                props.setFilterParameters(selected, "acId")
                            }
                            allowSelectAll={false}
                            value={props.partyDropdownList.filter(
                                (party) =>
                                    party.value === props.invoiceDetails.acId
                            )}
                        />
                        {/* <ValidationText error={props.validState.error.acId} /> */}
                    </div>
                </div>
                <div className="item-grp !flex !gap-2.5 !mb-3">
                    <div className="input-grp w-full">
                        <label>A/c Narration</label>
                        <input
                            type="text"
                            id="acNarration1"
                            name="acNarration1"
                            className="inputFocus w-full"
                            autocomplete="off"
                            value={props.invoiceDetails.acNarration1}
                            onChange={(event) =>
                                props.handleChange(event, "acNarration1", "invoiceDetails")
                            }
                        />
                    </div>
                    <div className="input-grp w-full ">
                        <label>A/c Narration</label>
                        <input
                            type="text"
                            id="acNarration2"
                            name="acNarration2"
                            className="inputFocus w-full"
                            autocomplete="off"
                            value={props.invoiceDetails.acNarration2}
                            onChange={(event) =>
                                props.handleChange(event, "acNarration2", "invoiceDetails")
                            }
                        />
                    </div>
                </div>
                <div className="item-grp !flex !gap-2.5 !mb-3">
                    <div className="search-grp w-full">
                        <label>GST Apply</label>
                        <select
                            name="gstApply"
                            className="w-full"
                            value={props.invoiceDetails.gstApply
                                && props.invoiceDetails.gstApply !== 'Select'
                                && props.List.find((party) => party.value === props.invoiceDetails.gstApply).value}
                            onChange={(event) =>
                                props.handleDropDownChange(
                                    event,
                                    "gstApply",
                                    "invoiceDetails"
                                )
                            }
                        >
                            {props.List.map((x, key) => (
                                <option key={key} value={x.value}>
                                    {x.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="search-grp w-full">
                        <label>Self Issue</label>
                        <select
                            name="selfIssue"
                            className="w-full"
                            value={props.invoiceDetails.selfIssue
                                && props.invoiceDetails.selfIssue !== 'Select'
                                && props.List.find((party) => party.value === props.invoiceDetails.selfIssue).value}
                            onChange={(event) =>
                                props.handleDropDownChange(
                                    event,
                                    "selfIssue",
                                    "invoiceDetails"
                                )
                            }
                        >
                            {props.List.map((x, key) => (
                                <option key={key} value={x.value}>
                                    {x.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="search-grp w-full">
                        <label>RCM</label>
                        <select
                            name="rcm"
                            className="w-full"
                            value={props.invoiceDetails.rcm
                                && props.invoiceDetails.rcm !== 'Select'
                                && props.List.find((party) => party.value === props.invoiceDetails.rcm).value}
                            onChange={(event) =>
                                props.handleDropDownChange(
                                    event,
                                    "rcm",
                                    "invoiceDetails"
                                )
                            }
                        >
                            {props.List.map((x, key) => (
                                <option key={key} value={x.value}>
                                    {x.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <hr />
                <div className="item-grp !flex !gap-2.5 mt-3">
                    <div className="input-grp w-[75%]">
                        <label>Description</label>
                        <input
                            type="text"
                            id="description1"
                            name="description1"
                            className="inputFocus w-full"
                            autocomplete="off"
                            value={props.invoiceDetails.description1}
                            onChange={(event) =>
                                props.handleChange(event, "description1", "invoiceDetails")
                            }
                        />
                        <input
                            type="text"
                            id="description2"
                            name="description2"
                            className="inputFocus w-full mt-3"
                            autocomplete="off"
                            value={props.invoiceDetails.description2}
                            onChange={(event) =>
                                props.handleChange(event, "description2", "invoiceDetails")
                            }
                        />
                        <input
                            type="text"
                            id="description3"
                            name="description3"
                            className="inputFocus w-full mt-3"
                            autocomplete="off"
                            value={props.invoiceDetails.description3}
                            onChange={(event) =>
                                props.handleChange(event, "description3", "invoiceDetails")
                            }
                        />
                        <input
                            type="text"
                            id="description4"
                            name="description4"
                            className="inputFocus w-full mt-3"
                            autocomplete="off"
                            value={props.invoiceDetails.description4}
                            onChange={(event) =>
                                props.handleChange(event, "description4", "invoiceDetails")
                            }
                        />
                        <input
                            type="text"
                            id="description5"
                            name="description5"
                            className="inputFocus w-full mt-3"
                            autocomplete="off"
                            value={props.invoiceDetails.description5}
                            onChange={(event) =>
                                props.handleChange(event, "description5", "invoiceDetails")
                            }
                        />

                    </div>
                    <div className="input-grp w-[25%] ">
                        <label>Amount</label>
                        <input
                            className="inputFocus "
                            type="number"
                            id="amount1"
                            name="amount1"
                            autoComplete="off"
                            value={props.invoiceDetails.amount1}
                            onChange={(event) =>
                                props.handleChange(event, "amount1", "invoiceDetails")
                            }
                        />
                        <input
                            className="inputFocus  mt-3"
                            type="number"
                            id="amount2"
                            name="amount2"
                            autoComplete="off"
                            value={props.invoiceDetails.amount2}
                            onChange={(event) =>
                                props.handleChange(event, "amount2", "invoiceDetails")
                            }
                        />
                        <input
                            className="inputFocus  mt-3"
                            type="number"
                            id="amount3"
                            name="amount3"
                            autoComplete="off"
                            value={props.invoiceDetails.amount3}
                            onChange={(event) =>
                                props.handleChange(event, "amount3", "invoiceDetails")
                            }
                        />
                        <input
                            className="inputFocus  mt-3"
                            type="number"
                            id="amount4"
                            name="amount4"
                            autoComplete="off"
                            value={props.invoiceDetails.amount4}
                            onChange={(event) =>
                                props.handleChange(event, "amount4", "invoiceDetails")
                            }
                        />
                        <input
                            className="inputFocus  mt-3"
                            type="number"
                            id="amount5"
                            name="amount5"
                            autoComplete="off"
                            value={props.invoiceDetails.amount5}
                            onChange={(event) =>
                                props.handleChange(event, "amount5", "invoiceDetails")
                            }
                        />

                    </div>
                </div>
                <div className='!flex !gap-3.5 mt-3.5'>
                    <div className='w-[75%]'>
                        <div className="item-grp !flex !gap-2.5 ">
                            <div className="input-grp min-w-[40%]">
                                <label>HSN/SAC Code</label>
                                <input
                                    className={`inputFocus ${props.validState?.error?.hsnSacCode ? "errorInput" : ""}`}
                                    type="number"
                                    id="hsnSacCode"
                                    name="hsnSacCode"
                                    autoComplete="off"
                                    value={props.invoiceDetails.hsnSacCode}
                                    onChange={(event) =>
                                        props.handleChange(event, "hsnSacCode", "invoiceDetails")
                                    }
                                />
                                {/* <ValidationText error={props.validState.error.hsnSacCode} /> */}
                            </div>
                            <div className="input-grp w-full">
                                <label>SGST [%]</label>
                                <input className="inputFocus"
                                    type="number"
                                    id="sgst"
                                    name="sgst"
                                    autoComplete="off"
                                    disabled={props.invoiceDetails.gstApply === 'no' ? true : false}
                                    value={props.invoiceDetails.sgst}
                                    onChange={(event) =>
                                        props.handleChange(event, "sgst", "invoiceDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>CGST [%]</label>
                                <input className="inputFocus"
                                    type="number"
                                    id="cgst"
                                    name="cgst"
                                    autoComplete="off"
                                    disabled={props.invoiceDetails.gstApply === 'no' ? true : false}
                                    value={props.invoiceDetails.cgst}
                                    onChange={(event) =>
                                        props.handleChange(event, "cgst", "invoiceDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>IGST [%]</label>
                                <input className="inputFocus"
                                    type="number"
                                    id="igst"
                                    name="igst"
                                    autoComplete="off"
                                    disabled={props.invoiceDetails.gstApply === 'no' ? true : false}
                                    value={props.invoiceDetails.igst}
                                    onChange={(event) =>
                                        props.handleChange(event, "igst", "invoiceDetails")
                                    }
                                />
                            </div>
                        </div>
                        <div className="item-grp !flex !gap-2.5 mt-3 ">
                            <div className="input-grp min-w-[40%]">
                                <label>HSN Description</label>
                                <input
                                    type="text"
                                    id="hsnDescription"
                                    name="hsnDescription"
                                    autoComplete="off"
                                    className='inputFocus'
                                    value={props.invoiceDetails.hsnDescription}
                                    onChange={(event) =>
                                        props.handleChange(event, "hsnDescription", "invoiceDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>SGST Amount</label>
                                <input className="inputFocus"
                                    type="number"
                                    id="sgstAmount"
                                    name="sgstAmount"
                                    autoComplete="off"
                                    disabled
                                    value={props.invoiceDetails.sgstAmount}
                                    onChange={(event) =>
                                        props.handleChange(event, "sgstAmount", "invoiceDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>CGST Amount</label>
                                <input className="inputFocus"
                                    type="number"
                                    id="cgstAmount"
                                    name="cgstAmount"
                                    autoComplete="off"
                                    disabled
                                    value={props.invoiceDetails.cgstAmount}
                                    onChange={(event) =>
                                        props.handleChange(event, "cgstAmount", "invoiceDetails")
                                    }
                                />
                            </div>
                            <div className="input-grp w-full">
                                <label>IGST Amount</label>
                                <input className="inputFocus"
                                    type="number"
                                    id="igstAmount"
                                    name="igstAmount"
                                    autoComplete="off"
                                    disabled
                                    value={props.invoiceDetails.igstAmount}
                                    onChange={(event) =>
                                        props.handleChange(event, "igstAmount", "invoiceDetails")
                                    }
                                />
                            </div>
                        </div>
                        <div className="btn-grp flex gap-2.5 mt-4">
                            {props.isEditing ?
                                <button
                                    className="add-btn"
                                    onClick={() => props.addEditGeneralDebitNoteEntry()}
                                    disabled={props.isLoading}
                                >
                                    {props.isLoading === "save" ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                                </button> :
                                <button
                                    className="add-btn"
                                    onClick={() => props.addEditGeneralDebitNoteEntry()}
                                    disabled={props.isLoading}
                                >
                                    {props.isLoading === "save" ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                                </button>
                            }
                            {props.generalCreditDebitNoteId && props.generalCreditDebitNoteId !== '' ?
                                <button
                                    className="print-btn"
                                    onClick={() => props.generateDebitNoteEntryById()}
                                    disabled={props.isLoading}
                                >
                                    {props.isLoading === "print" ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Print"}
                                </button>
                                : null}
                            <button
                                className="cancel-btn"
                                onClick={props.openGridView}
                                disabled={props.isLoading}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>


                    <div className="item-sections w-[25%] mb-auto p-3  !bg-[#ffffff] rounded-[10px]" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', backgroundColor: "#f5f5f5 " }}>
                        <p className='text-center font-semibold'>Summary</p>
                        <div className="search-grp flex gap-2">
                            <div className="w-[35%] flex items-center text-[14px] font-medium text-[#585858] pt-[8px] ">
                                SUB Total
                            </div>
                            <input
                                className=" !w-[65%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                                type="number"
                                id="subTotal"
                                name="subTotal"
                                autocomplete="off"
                                disabled
                                value={props.invoiceDetails.subTotal}
                                onChange={(event) =>
                                    props.handleChange(event, "subTotal", "invoiceDetails")
                                }
                            />
                        </div>
                        <div className="search-grp flex gap-2.5 mt-[10px]">
                            <div className="w-[35%] flex items-center text-[14px] font-medium text-[#585858]">
                                Round Off
                            </div>
                            <input
                                className="inputFocus w-[65%] h-[40px]"
                                type="number"
                                id="roundOff"
                                name="roundOff"
                                autocomplete="off"
                                disabled
                                value={props.invoiceDetails.roundOff}
                                onChange={(event) =>
                                    props.handleChange(event, "roundOff", "invoiceDetails")
                                }
                            />
                        </div>
                        <div className="search-grp flex gap-2.5 mt-[10px]">
                            <div className="w-[35%] flex items-center text-[14px] font-medium text-[#585858]">
                                Grand Total
                            </div>
                            <input
                                className="inputFocus w-[65%] h-[40px]"
                                type="number"
                                id="grandTotal"
                                name="grandTotal"
                                autocomplete="off"
                                disabled
                                value={props.invoiceDetails.grandTotal}
                                onChange={(event) =>
                                    props.handleChange(event, "grandTotal", "invoiceDetails")
                                }
                            />
                        </div>
                    </div>
                </div>



            </div>
        </div>
    );
};
export default SecondPageDebitCreditNoteEntry;